(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-item-collection"] && !Shopify.designMode) return;
  try {
    (() => {
  if (window.BaageColorMix) return;

  const selector = '[data-baage-color-card]';
  const configurations = new WeakMap();
  const listStates = new WeakMap();
  const manualSelections = new WeakMap();
  const previousColors = new Map();
  const currentColors = new Map();
  let scheduled = false;
  let instance = 0;
  const swatchUpdates = new Set();
  const headers = new WeakSet();

  function colorKey(value) {
    return String(value).normalize('NFKC').trim().replace(/\s+/g, ' ').toLocaleLowerCase();
  }

  function configuration(card) {
    if (!configurations.has(card)) {
      try {
        const config = JSON.parse(card.getAttribute('data-baage-color-data'));
        const suffix = '-baage-mix-' + (++instance);
        card.querySelectorAll('.color-swatch__radio').forEach(input => {
          const originalId = input.id;
          card.querySelectorAll('label').forEach(label => {
            if (label.htmlFor === originalId) label.htmlFor = originalId + suffix;
          });
          input.id = originalId + suffix;
          input.name += suffix;
        });
        configurations.set(card, config);
      } catch (error) {
        configurations.set(card, null);
      }
    }
    return configurations.get(card);
  }

  function storageKey(productId) {
    return 'baage-color-v1:' + location.pathname + ':' + productId;
  }

  function previousColor(productId) {
    if (!previousColors.has(productId)) {
      let value = null;
      try { value = sessionStorage.getItem(storageKey(productId)); } catch (error) {}
      previousColors.set(productId, value);
    }
    return previousColors.get(productId);
  }

  function remember(productId, color) {
    previousColor(productId);
    currentColors.set(productId, colorKey(color));
    try { sessionStorage.setItem(storageKey(productId), colorKey(color)); } catch (error) {}
  }

  function allocate(cards, history) {
    const entries = cards.map((card, position) => {
      const config = configuration(card);
      const manual = manualSelections.get(card);
      const variants = manual ? [manual] : (config?.variants || []).filter(variant => variant.available && variant.matchesFilter && variant.image);
      return {card, config, variants, position};
    }).filter(entry => entry.variants.length);
    const colors = [...new Set(entries.flatMap(entry => entry.variants.map(variant => colorKey(variant.color))))];
    const source = 0;
    const colorStart = 1 + entries.length;
    const sink = colorStart + colors.length;
    const graph = Array.from({length: sink + 1}, () => []);

    function edge(from, to, capacity, cost, variant = null) {
      const forward = {to, reverse: graph[to].length, capacity, cost, variant};
      const backward = {to: from, reverse: graph[from].length, capacity: 0, cost: -cost};
      graph[from].push(forward);
      graph[to].push(backward);
    }

    entries.forEach((entry, index) => {
      edge(source, index + 1, 1, 0);
      const previous = previousColor(entry.config.productId);
      const current = currentColors.get(entry.config.productId);
      const recent = history.slice(Math.max(0, history.length - 5 + entry.position));
      entry.variants.forEach(variant => {
        const key = colorKey(variant.color);
        const cost = (key === previous ? 10000 : 0) + (current && key !== current ? 1000 : 0) + (recent.includes(key) ? 500 : 0) + Math.floor(Math.random() * 100);
        edge(index + 1, colorStart + colors.indexOf(key), 1, cost, variant);
      });
    });

    colors.forEach((color, index) => {
      for (let count = 0; count < entries.length; count++) {
        edge(colorStart + index, sink, 1, count === 0 ? 0 : 1000000 + count * 100);
      }
    });

    for (let flow = 0; flow < entries.length; flow++) {
      const distance = Array(graph.length).fill(Infinity);
      const path = Array(graph.length);
      distance[source] = 0;
      for (let pass = 0; pass < graph.length - 1; pass++) {
        let changed = false;
        graph.forEach((edges, from) => {
          edges.forEach((item, index) => {
            if (item.capacity > 0 && distance[from] + item.cost < distance[item.to]) {
              distance[item.to] = distance[from] + item.cost;
              path[item.to] = [from, index];
              changed = true;
            }
          });
        });
        if (!changed) break;
      }
      if (!Number.isFinite(distance[sink])) break;
      for (let node = sink; node !== source;) {
        const [from, index] = path[node];
        const item = graph[from][index];
        item.capacity--;
        graph[node][item.reverse].capacity++;
        node = from;
      }
    }

    return entries.map((entry, index) => ({
      card: entry.card,
      variant: graph[index + 1].find(item => item.variant && item.capacity === 0)?.variant
    })).filter(selection => selection.variant);
  }

  function updateImage(oldImage, details, alternate) {
    if (oldImage && oldImage.getAttribute('data-image-id') === details.id) {
      oldImage.alt = details.alt;
      return oldImage;
    }
    const image = document.createElement('img');
    image.className = (alternate ? 'secondary-image-javascript product-item__secondary-image' : 'product-item__primary-image') + ' lazyload image--fade-in';
    image.setAttribute('data-src', details.template);
    image.setAttribute('data-widths', JSON.stringify(details.widths));
    image.setAttribute('data-sizes', 'auto');
    image.setAttribute('data-image-id', details.id);
    image.setAttribute('data-media-id', details.mediaId || details.id);
    image.width = details.width;
    image.height = details.height;
    image.alt = details.alt;
    image.src = details.url;
    if (oldImage) oldImage.replaceWith(image);
    return image;
  }

  function keepSwatchVisible(card) {
    const list = card.querySelector('.product-item__swatch-list');
    if (!list) return;
    const swatches = [...list.querySelectorAll('.color-swatch')];
    const slots = Math.max(2, Math.floor(Math.min(list.clientWidth || 200, 200) / 50));
    const visibleCount = swatches.length <= slots ? swatches.length : slots - 1;
    const visible = swatches.slice(0, visibleCount);
    const checked = card.querySelector('.color-swatch__radio:checked')?.closest('.color-swatch');
    if (checked && !visible.includes(checked)) visible[visible.length - 1] = checked;
    swatches.forEach(swatch => {
      if (swatch.classList.contains('color-swatch--view-more')) swatch.classList.remove('color-swatch--view-more');
      const display = visible.includes(swatch) ? 'inline-block' : 'none';
      if (swatch.style.display !== display) swatch.style.display = display;
    });
    const count = list.querySelector('.color-swatch__item-link');
    if (count) {
      const hidden = swatches.length - visible.length;
      count.textContent = hidden > 0 ? '+' + hidden : '';
      count.style.display = hidden > 0 ? 'inline' : 'none';
    }
  }

  function preserveCollectionControls() {
    if (![...document.querySelectorAll(selector)].some(card => configuration(card)?.collectionCard)) return;
    document.querySelectorAll('.collection__filter-group').forEach(group => {
      if (group.querySelector('#mobile-filter-p-m-product-brand_shortname, #filter-p-m-product-brand_shortname')) group.style.display = 'none';
    });
    const header = document.getElementById('shopify-section-header');
    if (header && !headers.has(header)) {
      headers.add(header);
      header.addEventListener('click', () => {
        if (window.matchMedia('(max-width: 640px)').matches) header.style.setProperty('z-index', header.getElementsByClassName('is-fixed').length ? '3' : '4', 'important');
      });
    }
  }

  function updatePrice(card, variant, config) {
    const list = card.querySelector('.product-item__price-list');
    if (!list) return;
    const sale = variant.compareAtPrice > variant.price;
    list.replaceChildren();
    function priceSpan(html, className, label) {
      const span = document.createElement('span');
      span.className = className;
      const hidden = document.createElement('span');
      hidden.className = 'visually-hidden';
      hidden.textContent = label;
      span.append(hidden);
      const template = document.createElement('template');
      template.innerHTML = html;
      span.append(template.content.cloneNode(true));
      return span;
    }
    const price = priceSpan(variant.priceHtml, 'price' + (sale ? ' price--highlight' : ''), config.saleLabel);
    const compare = sale ? priceSpan(variant.compareHtml, 'price price--compare', config.regularLabel) : null;
    if (config.collectionCard && compare) {
      compare.style.marginRight = '0.7em';
      list.append(compare);
    }
    list.append(price);
    if (!config.collectionCard && compare) list.append(compare);
    if (config.collectionCard && sale) {
      const percent = document.createElement('span');
      percent.className = 'price-percentage-difference';
      const value = document.createElement('span');
      value.className = 'percentage_difference';
      value.textContent = '-' + Math.round((variant.compareAtPrice - variant.price) / variant.compareAtPrice * 100) + '%';
      percent.append(value);
      list.append(percent);
    }
    let badge = card.querySelector('.product-label--on-sale');
    if (config.showDiscount && sale) {
      if (!badge) {
        let labels = card.querySelector('.product-item__label-list');
        if (!labels) {
          labels = document.createElement('div');
          labels.className = 'product-item__label-list';
          card.prepend(labels);
        }
        badge = document.createElement('span');
        badge.className = 'product-label product-label--on-sale';
        labels.append(badge);
      }
      badge.innerHTML = variant.discountHtml;
    } else badge?.remove();
  }

  function apply(card, variant) {
    const config = configuration(card);
    card.querySelectorAll('.product-item__image-wrapper, .product-item__title, .color-swatch__item-link').forEach(link => link.setAttribute('href', variant.url));
    card.querySelectorAll('.product-item__reviews-badge').forEach(link => link.setAttribute('href', variant.url + '#product-reviews'));
    card.querySelectorAll('.product-item__action-list a').forEach(link => {
      if (new URL(link.href, location.href).pathname === new URL(variant.url, location.href).pathname) link.setAttribute('href', variant.url);
    });
    card.querySelectorAll('[data-secondary-action="open-quick-view"]').forEach(button => button.setAttribute('data-product-url', variant.url));
    card.querySelectorAll('form[action*="/cart/add"] input[name="id"]').forEach(input => { input.value = variant.id; });
    let selectedInput = false;
    card.querySelectorAll('.color-swatch__radio').forEach(input => {
      const selected = !selectedInput && colorKey(input.value) === colorKey(variant.color);
      input.checked = selected;
      if (selected) {
        selectedInput = true;
        input.setAttribute('data-variant-url', variant.url);
        input.setAttribute('data-price', variant.price);
        input.setAttribute('data-compare-at-price', variant.compareAtPrice > variant.price ? variant.compareAtPrice : '');
        if (variant.image) {
          input.setAttribute('data-media-id', variant.image.mediaId || variant.image.id);
          input.setAttribute('data-image-url', variant.image.template);
          input.setAttribute('data-image-widths', JSON.stringify(variant.image.widths));
          input.setAttribute('data-image-aspect-ratio', variant.image.ratio);
        }
      }
    });
    const wrapper = card.querySelector('.product-item__image-wrapper');
    const original = wrapper?.querySelector('.product-item__primary-image');
    if (original && variant.image) {
      const image = updateImage(original, variant.image, false);
      const aspect = image.parentElement;
      aspect.style.paddingBottom = 100 / variant.image.ratio + '%';
      const alternate = aspect.querySelector('.product-item__secondary-image');
      if (config.secondary && variant.alternate) {
        const secondary = updateImage(alternate, variant.alternate, true);
        if (!secondary.parentElement) aspect.append(secondary);
        wrapper.classList.add('product-item__image-wrapper--with-secondary');
        window.lazySizes?.loader?.unveil(secondary);
      } else {
        alternate?.remove();
        wrapper.classList.remove('product-item__image-wrapper--with-secondary');
      }
      window.lazySizes?.loader?.unveil(image);
    } else wrapper?.classList.remove('product-item__image-wrapper--with-secondary');
    updatePrice(card, variant, config);
    card.setAttribute('data-baage-selected-color', variant.color);
    keepSwatchVisible(card);
    remember(config.productId, variant.color);
  }

  function refresh() {
    scheduled = false;
    const lists = new Map();
    document.querySelectorAll(selector).forEach(card => {
      if (!configuration(card)) return;
      const list = card.closest('.product-list') || card.closest('[data-section-id]') || card.parentElement;
      if (!lists.has(list)) lists.set(list, []);
      lists.get(list).push(card);
    });
    preserveCollectionControls();
    lists.forEach((cards, list) => {
      const old = listStates.get(list);
      if (old && old.length === cards.length && old.every((card, index) => card === cards[index])) return;
      listStates.set(list, cards);
      const history = [];
      for (let offset = 0; offset < cards.length; offset += 6) {
        const block = cards.slice(offset, offset + 6);
        const selections = allocate(block, history);
        selections.forEach(selection => apply(selection.card, selection.variant));
        block.forEach(card => {
          const color = card.getAttribute('data-baage-selected-color');
          history.push(color ? colorKey(color) : null);
        });
      }
    });
    swatchUpdates.forEach(card => { if (card.isConnected) keepSwatchVisible(card); });
    swatchUpdates.clear();
  }

  function schedule() {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(refresh);
  }

  window.BaageColorMix = {refresh: schedule};
  document.addEventListener('change', event => {
    if (!event.target.matches('.color-swatch__radio')) return;
    const card = event.target.closest(selector);
    if (!card) return;
    const config = configuration(card);
    const variant = config?.variants.find(item => colorKey(item.color) === colorKey(event.target.value));
    if (!variant) return;
    manualSelections.set(card, variant);
    apply(card, variant);
  }, true);

  const observer = new MutationObserver(records => {
    let changed = false;
    records.forEach(record => {
      if (record.type === 'attributes' && record.target.matches('.color-swatch')) {
        const card = record.target.closest(selector);
        if (card) { swatchUpdates.add(card); changed = true; }
      }
      [...record.addedNodes].forEach(node => {
        if (node.nodeType === 1 && (node.matches(selector + ', .collection__filter-group') || node.querySelector(selector + ', .collection__filter-group'))) changed = true;
      });
    });
    if (changed) schedule();
  });
  observer.observe(document.documentElement, {childList: true, subtree: true, attributes: true, attributeFilter: ['class']});
  window.addEventListener('resize', () => {
    document.querySelectorAll(selector).forEach(card => swatchUpdates.add(card));
    schedule();
  });
  document.addEventListener('shopify:section:load', schedule);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', refresh, {once: true});
  else refresh();
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-item"] && !Shopify.designMode) return;
  try {
    (() => {
  if (window.BaageColorMix) return;

  const selector = '[data-baage-color-card]';
  const configurations = new WeakMap();
  const listStates = new WeakMap();
  const manualSelections = new WeakMap();
  const previousColors = new Map();
  const currentColors = new Map();
  let scheduled = false;
  let instance = 0;
  const swatchUpdates = new Set();
  const headers = new WeakSet();

  function colorKey(value) {
    return String(value).normalize('NFKC').trim().replace(/\s+/g, ' ').toLocaleLowerCase();
  }

  function configuration(card) {
    if (!configurations.has(card)) {
      try {
        const config = JSON.parse(card.getAttribute('data-baage-color-data'));
        const suffix = '-baage-mix-' + (++instance);
        card.querySelectorAll('.color-swatch__radio').forEach(input => {
          const originalId = input.id;
          card.querySelectorAll('label').forEach(label => {
            if (label.htmlFor === originalId) label.htmlFor = originalId + suffix;
          });
          input.id = originalId + suffix;
          input.name += suffix;
        });
        configurations.set(card, config);
      } catch (error) {
        configurations.set(card, null);
      }
    }
    return configurations.get(card);
  }

  function storageKey(productId) {
    return 'baage-color-v1:' + location.pathname + ':' + productId;
  }

  function previousColor(productId) {
    if (!previousColors.has(productId)) {
      let value = null;
      try { value = sessionStorage.getItem(storageKey(productId)); } catch (error) {}
      previousColors.set(productId, value);
    }
    return previousColors.get(productId);
  }

  function remember(productId, color) {
    previousColor(productId);
    currentColors.set(productId, colorKey(color));
    try { sessionStorage.setItem(storageKey(productId), colorKey(color)); } catch (error) {}
  }

  function allocate(cards, history) {
    const entries = cards.map((card, position) => {
      const config = configuration(card);
      const manual = manualSelections.get(card);
      const variants = manual ? [manual] : (config?.variants || []).filter(variant => variant.available && variant.matchesFilter && variant.image);
      return {card, config, variants, position};
    }).filter(entry => entry.variants.length);
    const colors = [...new Set(entries.flatMap(entry => entry.variants.map(variant => colorKey(variant.color))))];
    const source = 0;
    const colorStart = 1 + entries.length;
    const sink = colorStart + colors.length;
    const graph = Array.from({length: sink + 1}, () => []);

    function edge(from, to, capacity, cost, variant = null) {
      const forward = {to, reverse: graph[to].length, capacity, cost, variant};
      const backward = {to: from, reverse: graph[from].length, capacity: 0, cost: -cost};
      graph[from].push(forward);
      graph[to].push(backward);
    }

    entries.forEach((entry, index) => {
      edge(source, index + 1, 1, 0);
      const previous = previousColor(entry.config.productId);
      const current = currentColors.get(entry.config.productId);
      const recent = history.slice(Math.max(0, history.length - 5 + entry.position));
      entry.variants.forEach(variant => {
        const key = colorKey(variant.color);
        const cost = (key === previous ? 10000 : 0) + (current && key !== current ? 1000 : 0) + (recent.includes(key) ? 500 : 0) + Math.floor(Math.random() * 100);
        edge(index + 1, colorStart + colors.indexOf(key), 1, cost, variant);
      });
    });

    colors.forEach((color, index) => {
      for (let count = 0; count < entries.length; count++) {
        edge(colorStart + index, sink, 1, count === 0 ? 0 : 1000000 + count * 100);
      }
    });

    for (let flow = 0; flow < entries.length; flow++) {
      const distance = Array(graph.length).fill(Infinity);
      const path = Array(graph.length);
      distance[source] = 0;
      for (let pass = 0; pass < graph.length - 1; pass++) {
        let changed = false;
        graph.forEach((edges, from) => {
          edges.forEach((item, index) => {
            if (item.capacity > 0 && distance[from] + item.cost < distance[item.to]) {
              distance[item.to] = distance[from] + item.cost;
              path[item.to] = [from, index];
              changed = true;
            }
          });
        });
        if (!changed) break;
      }
      if (!Number.isFinite(distance[sink])) break;
      for (let node = sink; node !== source;) {
        const [from, index] = path[node];
        const item = graph[from][index];
        item.capacity--;
        graph[node][item.reverse].capacity++;
        node = from;
      }
    }

    return entries.map((entry, index) => ({
      card: entry.card,
      variant: graph[index + 1].find(item => item.variant && item.capacity === 0)?.variant
    })).filter(selection => selection.variant);
  }

  function updateImage(oldImage, details, alternate) {
    if (oldImage && oldImage.getAttribute('data-image-id') === details.id) {
      oldImage.alt = details.alt;
      return oldImage;
    }
    const image = document.createElement('img');
    image.className = (alternate ? 'secondary-image-javascript product-item__secondary-image' : 'product-item__primary-image') + ' lazyload image--fade-in';
    image.setAttribute('data-src', details.template);
    image.setAttribute('data-widths', JSON.stringify(details.widths));
    image.setAttribute('data-sizes', 'auto');
    image.setAttribute('data-image-id', details.id);
    image.setAttribute('data-media-id', details.mediaId || details.id);
    image.width = details.width;
    image.height = details.height;
    image.alt = details.alt;
    image.src = details.url;
    if (oldImage) oldImage.replaceWith(image);
    return image;
  }

  function keepSwatchVisible(card) {
    const list = card.querySelector('.product-item__swatch-list');
    if (!list) return;
    const swatches = [...list.querySelectorAll('.color-swatch')];
    const slots = Math.max(2, Math.floor(Math.min(list.clientWidth || 200, 200) / 50));
    const visibleCount = swatches.length <= slots ? swatches.length : slots - 1;
    const visible = swatches.slice(0, visibleCount);
    const checked = card.querySelector('.color-swatch__radio:checked')?.closest('.color-swatch');
    if (checked && !visible.includes(checked)) visible[visible.length - 1] = checked;
    swatches.forEach(swatch => {
      if (swatch.classList.contains('color-swatch--view-more')) swatch.classList.remove('color-swatch--view-more');
      const display = visible.includes(swatch) ? 'inline-block' : 'none';
      if (swatch.style.display !== display) swatch.style.display = display;
    });
    const count = list.querySelector('.color-swatch__item-link');
    if (count) {
      const hidden = swatches.length - visible.length;
      count.textContent = hidden > 0 ? '+' + hidden : '';
      count.style.display = hidden > 0 ? 'inline' : 'none';
    }
  }

  function preserveCollectionControls() {
    if (![...document.querySelectorAll(selector)].some(card => configuration(card)?.collectionCard)) return;
    document.querySelectorAll('.collection__filter-group').forEach(group => {
      if (group.querySelector('#mobile-filter-p-m-product-brand_shortname, #filter-p-m-product-brand_shortname')) group.style.display = 'none';
    });
    const header = document.getElementById('shopify-section-header');
    if (header && !headers.has(header)) {
      headers.add(header);
      header.addEventListener('click', () => {
        if (window.matchMedia('(max-width: 640px)').matches) header.style.setProperty('z-index', header.getElementsByClassName('is-fixed').length ? '3' : '4', 'important');
      });
    }
  }

  function updatePrice(card, variant, config) {
    const list = card.querySelector('.product-item__price-list');
    if (!list) return;
    const sale = variant.compareAtPrice > variant.price;
    list.replaceChildren();
    function priceSpan(html, className, label) {
      const span = document.createElement('span');
      span.className = className;
      const hidden = document.createElement('span');
      hidden.className = 'visually-hidden';
      hidden.textContent = label;
      span.append(hidden);
      const template = document.createElement('template');
      template.innerHTML = html;
      span.append(template.content.cloneNode(true));
      return span;
    }
    const price = priceSpan(variant.priceHtml, 'price' + (sale ? ' price--highlight' : ''), config.saleLabel);
    const compare = sale ? priceSpan(variant.compareHtml, 'price price--compare', config.regularLabel) : null;
    if (config.collectionCard && compare) {
      compare.style.marginRight = '0.7em';
      list.append(compare);
    }
    list.append(price);
    if (!config.collectionCard && compare) list.append(compare);
    if (config.collectionCard && sale) {
      const percent = document.createElement('span');
      percent.className = 'price-percentage-difference';
      const value = document.createElement('span');
      value.className = 'percentage_difference';
      value.textContent = '-' + Math.round((variant.compareAtPrice - variant.price) / variant.compareAtPrice * 100) + '%';
      percent.append(value);
      list.append(percent);
    }
    let badge = card.querySelector('.product-label--on-sale');
    if (config.showDiscount && sale) {
      if (!badge) {
        let labels = card.querySelector('.product-item__label-list');
        if (!labels) {
          labels = document.createElement('div');
          labels.className = 'product-item__label-list';
          card.prepend(labels);
        }
        badge = document.createElement('span');
        badge.className = 'product-label product-label--on-sale';
        labels.append(badge);
      }
      badge.innerHTML = variant.discountHtml;
    } else badge?.remove();
  }

  function apply(card, variant) {
    const config = configuration(card);
    card.querySelectorAll('.product-item__image-wrapper, .product-item__title, .color-swatch__item-link').forEach(link => link.setAttribute('href', variant.url));
    card.querySelectorAll('.product-item__reviews-badge').forEach(link => link.setAttribute('href', variant.url + '#product-reviews'));
    card.querySelectorAll('.product-item__action-list a').forEach(link => {
      if (new URL(link.href, location.href).pathname === new URL(variant.url, location.href).pathname) link.setAttribute('href', variant.url);
    });
    card.querySelectorAll('[data-secondary-action="open-quick-view"]').forEach(button => button.setAttribute('data-product-url', variant.url));
    card.querySelectorAll('form[action*="/cart/add"] input[name="id"]').forEach(input => { input.value = variant.id; });
    let selectedInput = false;
    card.querySelectorAll('.color-swatch__radio').forEach(input => {
      const selected = !selectedInput && colorKey(input.value) === colorKey(variant.color);
      input.checked = selected;
      if (selected) {
        selectedInput = true;
        input.setAttribute('data-variant-url', variant.url);
        input.setAttribute('data-price', variant.price);
        input.setAttribute('data-compare-at-price', variant.compareAtPrice > variant.price ? variant.compareAtPrice : '');
        if (variant.image) {
          input.setAttribute('data-media-id', variant.image.mediaId || variant.image.id);
          input.setAttribute('data-image-url', variant.image.template);
          input.setAttribute('data-image-widths', JSON.stringify(variant.image.widths));
          input.setAttribute('data-image-aspect-ratio', variant.image.ratio);
        }
      }
    });
    const wrapper = card.querySelector('.product-item__image-wrapper');
    const original = wrapper?.querySelector('.product-item__primary-image');
    if (original && variant.image) {
      const image = updateImage(original, variant.image, false);
      const aspect = image.parentElement;
      aspect.style.paddingBottom = 100 / variant.image.ratio + '%';
      const alternate = aspect.querySelector('.product-item__secondary-image');
      if (config.secondary && variant.alternate) {
        const secondary = updateImage(alternate, variant.alternate, true);
        if (!secondary.parentElement) aspect.append(secondary);
        wrapper.classList.add('product-item__image-wrapper--with-secondary');
        window.lazySizes?.loader?.unveil(secondary);
      } else {
        alternate?.remove();
        wrapper.classList.remove('product-item__image-wrapper--with-secondary');
      }
      window.lazySizes?.loader?.unveil(image);
    } else wrapper?.classList.remove('product-item__image-wrapper--with-secondary');
    updatePrice(card, variant, config);
    card.setAttribute('data-baage-selected-color', variant.color);
    keepSwatchVisible(card);
    remember(config.productId, variant.color);
  }

  function refresh() {
    scheduled = false;
    const lists = new Map();
    document.querySelectorAll(selector).forEach(card => {
      if (!configuration(card)) return;
      const list = card.closest('.product-list') || card.closest('[data-section-id]') || card.parentElement;
      if (!lists.has(list)) lists.set(list, []);
      lists.get(list).push(card);
    });
    preserveCollectionControls();
    lists.forEach((cards, list) => {
      const old = listStates.get(list);
      if (old && old.length === cards.length && old.every((card, index) => card === cards[index])) return;
      listStates.set(list, cards);
      const history = [];
      for (let offset = 0; offset < cards.length; offset += 6) {
        const block = cards.slice(offset, offset + 6);
        const selections = allocate(block, history);
        selections.forEach(selection => apply(selection.card, selection.variant));
        block.forEach(card => {
          const color = card.getAttribute('data-baage-selected-color');
          history.push(color ? colorKey(color) : null);
        });
      }
    });
    swatchUpdates.forEach(card => { if (card.isConnected) keepSwatchVisible(card); });
    swatchUpdates.clear();
  }

  function schedule() {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(refresh);
  }

  window.BaageColorMix = {refresh: schedule};
  document.addEventListener('change', event => {
    if (!event.target.matches('.color-swatch__radio')) return;
    const card = event.target.closest(selector);
    if (!card) return;
    const config = configuration(card);
    const variant = config?.variants.find(item => colorKey(item.color) === colorKey(event.target.value));
    if (!variant) return;
    manualSelections.set(card, variant);
    apply(card, variant);
  }, true);

  const observer = new MutationObserver(records => {
    let changed = false;
    records.forEach(record => {
      if (record.type === 'attributes' && record.target.matches('.color-swatch')) {
        const card = record.target.closest(selector);
        if (card) { swatchUpdates.add(card); changed = true; }
      }
      [...record.addedNodes].forEach(node => {
        if (node.nodeType === 1 && (node.matches(selector + ', .collection__filter-group') || node.querySelector(selector + ', .collection__filter-group'))) changed = true;
      });
    });
    if (changed) schedule();
  });
  observer.observe(document.documentElement, {childList: true, subtree: true, attributes: true, attributeFilter: ['class']});
  window.addEventListener('resize', () => {
    document.querySelectorAll(selector).forEach(card => swatchUpdates.add(card));
    schedule();
  });
  document.addEventListener('shopify:section:load', schedule);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', refresh, {once: true});
  else refresh();
})();
  } catch(e) { console.error(e); }
})();

})();
